import {
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { ErrorMonitoring } from 'core/common/services/errorMonitoring';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { FacebookService } from '../../interfaces/FacebookService';
import { FacebookServiceWithMonitoring } from './FacebookServiceWithMonitoring';

export class FacebookServiceBuilder {
  constructor(private facebookService: FacebookService) {}

  addMonitoring(
    observabilitySystem: ObservabilitySystem,
    errorMonitoringService: ErrorMonitoring,
    funnelSettingsService: FunnelSettingsServiceInterface,
  ): this {
    const provideAdditionalObservabilityAttributes = () => {
      return {
        [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
        [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
      };
    };

    this.facebookService = new FacebookServiceWithMonitoring(
      this.facebookService,
      observabilitySystem,
      errorMonitoringService,
      provideAdditionalObservabilityAttributes,
    );

    return this;
  }

  getResult(): FacebookService {
    return this.facebookService;
  }
}
